import currentFilteredResource from './currentFilteredResource';
import expandedRows from './expandedRows';
import mostRecentCreated from './mostRecentCreated';
import previousRoute from './previousRoute';

export default { mostRecentCreated, currentFilteredResource,previousRoute,  expandedRows }
